import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=967759c8&scoped=true"
import script from "./HeaderCard.vue?vue&type=script&lang=ts"
export * from "./HeaderCard.vue?vue&type=script&lang=ts"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=967759c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967759c8",
  null
  
)

export default component.exports